export default __webpack_public_path__ + "static/media/defaultProfilePic.7cb7d14d.jpg";